export default __webpack_public_path__ + "static/media/Technologies-mobile.bbd01197.png";